<div class="container-inco">
  <div class="inner-tcontainer-tab">
    <div class="header-container">
      <div class="header-left">
        <h2>{{title}}</h2>
        <p style="color: #e57373; font-weight: bold; margin-top: 5px; margin-bottom: 0;">Please enter values as YTD and in local Currency</p>
      </div>
    </div>

    <div class="action-bar">
      <div class="action-buttons-left">

      </div>

      <div class="action-buttons-right">
        @if (isEditModeEnabled) {
          <a class='kpi-save-menu save-button'
            [class.disabled]="!isVerified"
            title="{{isVerified ? 'Save' : 'Please verify values before saving'}}"
            (click)="isVerified && onClickSave()">
            <span class='glyphicon glyphicon-floppy-disk'></span> Save
          </a>
        }

        @if (isEditModeEnabled && tableData.length > 1) {
          <a class='kpi-button-menu'
            [class.verify-success]="verificationStatus === 'success'"
            [class.verify-error]="verificationStatus === 'error'"
            [class.disabled]="!hasChanges()"
            title="{{hasChanges() ? 'Verify values with SAP' : 'Please edit values before verifying'}}"
            (click)="hasChanges() && onClickVerify()"
            >
            <span class='glyphicon glyphicon-ok-circle'></span> Validate
          </a>
        }

        @if (!isExcelModeEnabled && !isEditModeEnabled) {
          <a class='kpi-button-menu' title="Excel" (click)="onClickExcel()">
            Excel
          </a>
        }

        @if (isExcelModeEnabled) {
          <a class='kpi-button-menu' title="Download" (click)="onClickDownload()">
            <span class='glyphicon glyphicon-download'></span> Download
          </a>
        }

        @if (isExcelModeEnabled) {
          <a class='kpi-button-menu' title="Upload" (click)="onClickUpload()">
            <span class='glyphicon glyphicon-upload'></span> Upload
          </a>
        }


        @if (isExcelModeEnabled) {
          <a class='kpi-button-menu' title="Exit Excel Mode" (click)="onClickExitExcel()">
            Exit Excel Mode
          </a>
        }

        @if (!isExcelModeEnabled) {
          <a class='kpi-button-menu' title="Edit values" (click)="onClickEdit()">
            <span class='glyphicon glyphicon-pencil'></span> {{isEditModeEnabled ? 'Undo' : 'Edit'}}
          </a>
        }
      </div>
    </div>

    <div class="status-bar">
      @if (isEditModeEnabled && !isVerified) {
        <h5 class="edit-mode-notice">
          <span class="salmon-color">Edit Mode is enabled. Please verify values with SAP before saving.</span>
        </h5>
      }
      @if (isEditModeEnabled && isVerified) {
        <h5 class="edit-mode-notice">
          <span class="success-color">Verification passed! You can now save your changes.</span>
        </h5>
      }
    </div>

    <app-data-table
      [columns]="tableColumns"
      [data]="tableData"
      [loading]="isLoading"
      [editMode]="isEditModeEnabled"
      [editableFromIndex]="1"
      [isRowEditable]="isRowEditableFn"
      [hasTotalRow]="true"
      [totalRowIndex]="0"
      [alternateRowColors]="true"
      [highlightOnHover]="true"
      [emptyMessage]="'No projects found for the selected branch and fiscal year.'"
      [loadingMessage]="'Loading projects...'"
      (cellValueChange)="onCellValueChange($event)"
      (historyClick)="viewChangeLog($event)">
    </app-data-table>

  </div>
</div>
